import { combineReducers } from 'redux';
import democracyEngineReducer from './democracyengine/reducers';
import donatePageReducer from './donatePage/reducers';
import eventPageReducer from './eventPage/reducers';
import faqsReducer from './faqs/reducers';
import galleryReducer from './gallery/reducers';
import impactReportReducer from './impactReport/reducers';
import payReducer from './pay/reducers';
import paymentsReducer from './payments/reducers';
import questionsReducer from './questions/reducers';
import recipientsReducer from './recipients/reducers';
import recommendationsReducer from './recommendations/reducers';
import setsReducer from './sets/reducers';
import siteConfigReducer from './siteConfig/reducers';
import subscriptionsReducer from './subscriptions/reducers';
import pagesReducer from './pages/reducers';
import transactionsReducer from './transactions/reducers';
import userReducer from './user/reducers';
import userStripeSubscriptionsReducer from './userStripeSubscriptions/reducers';
import shoppingCartSliceReducer from './shopping_cart/slice';
import userChatSliceReducer from './user_chat/slice';
import { siteApi } from 'services/siteApi';
import expressCheckoutSliceReducer from './expressCheckout/slice';
import contributionSummarySliceReducer from './contributionSummary/slice';

export default combineReducers({
  democracyEngine: democracyEngineReducer,
  donatePage: donatePageReducer,
  eventPage: eventPageReducer,
  faqs: faqsReducer,
  gallery: galleryReducer,
  impactReport: impactReportReducer,
  pay: payReducer,
  payments: paymentsReducer,
  [siteApi.reducerPath]: siteApi.reducer,
  shoppingCart: shoppingCartSliceReducer,
  questions: questionsReducer,
  recipients: recipientsReducer,
  recommendations: recommendationsReducer,
  sets: setsReducer,
  siteConfig: siteConfigReducer,
  subscriptions: subscriptionsReducer,
  pages: pagesReducer,
  transactions: transactionsReducer,
  user: userReducer,
  userChat: userChatSliceReducer,
  userStripeSubscriptions: userStripeSubscriptionsReducer,
  expressCheckout: expressCheckoutSliceReducer,
  contributionSummary: contributionSummarySliceReducer,
});
